var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66646 13.905C8.66646 14.595 9.23646 15.18 9.95647 15.18C10.6765 15.18 11.2465 14.595 11.2465 13.905C11.2465 13.215 10.6765 12.63 9.95647 12.63C9.23646 12.63 8.66646 13.215 8.66646 13.905ZM13.5715 7.41C13.5715 5.61 12.0865 4.305 10.0465 4.305C7.93146 4.305 6.49146 5.76 6.49146 7.83H8.66646C8.68146 7.02 9.25146 6.405 10.0315 6.405C10.8115 6.405 11.3365 6.945 11.3365 7.59C11.3365 8.115 10.9915 8.595 10.2865 9.075C9.34146 9.735 8.83147 10.5 8.83147 11.19V11.7H11.0065V11.415C11.0065 10.785 11.8015 10.335 12.3865 9.825C13.1815 9.12 13.5715 8.355 13.5715 7.41Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.62a533d0a064dd3f25accbe51aa7b303.svg";
export { ForwardRef as ReactComponent };